/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import axios                from 'axios';
import {apiUrl}               from '../../lib/constants';

/**
 * Bouton d'ajout d'un bloc
 */
class AddBlockButton extends Component {
    
    constructor(props){
        super(props);
        
        this.addBlock = this.addBlock.bind(this);
    }
    
    /**
     * Ajoute un bloc
     */
    addBlock(){
        axios.put(apiUrl + '/api/v1/admin/annexe', {titre: '', semaine: 0, nomInitial: '', nomFinal: null}).then((response) => {
            this.props.onBlockAdd(response.data);
        });
    }
    
    render(){
        return <button type="button" className="btn myBtn" onClick={this.addBlock}>Ajouter une annexe</button>;
    }
}

AddBlockButton.propTypes = { onBlockAdd: PropTypes.func };

export default AddBlockButton;


// WEBPACK FOOTER //
// ./src/components/annexes/AddBlockButton.js